// Single source of truth for debug mode (tester tooling gate). When ON:
//  - SELECT opens the battle-setup modal (script builder) instead of running a
//    battle directly,
//  - ESC during a battle aborts it and returns to the desktop.
//
// Default: on in dev (vite dev server), off in a production build. Force either
// way with the `?debug=1` / `?debug=0` query param.

const param = new URLSearchParams(window.location.search).get('debug');
let enabled = param !== null ? param !== '0' && param !== 'false' : import.meta.env.DEV;

export function isDebugMode(): boolean {
  return enabled;
}

export function setDebugMode(value: boolean): void {
  enabled = value;
}
